import {
  logUtil,
  omitObjectUtil
} from 'packages/src'

/**
 * Returns the route and match with the additional data if there is.
 * @param  {Object} props
 * @param  {Object} props.route
 * @param  {Object} props.match
 * @returns {Object}
 */
export default function getRouteAndMatchDataRouteUtil (props) {
  const {
    route,
    match
  } = props

  if (!route) {
    logUtil('getRouteAndMatchDataRouteUtil').debug('[noop] no route')
    return {
      route,
      match
    }
  }

  const {
    getData,
    path
  } = route
  const logPrefix = `path=${path}`
  if (!getData) {
    logUtil('getRouteAndMatchDataRouteUtil').debug(`${logPrefix} [noop] no getData`)
    return {
      route,
      match
    }
  }

  logUtil('getRouteAndMatchDataRouteUtil').debug(`${logPrefix} getData`)
  // Add additional params and data to the match and route
  const data = getData(match)
  const newMatch = { ...match }
  newMatch.params = {
    ...newMatch.params,
    ...data.params
  }

  const newRoute = {
    ...route,
    ...omitObjectUtil(data, ['params'])
  }

  return {
    route: newRoute,
    match: newMatch
  }
}
